import { Getter } from 'vuex'
import { AuthState } from '../types'
import { RootState } from '@/store/types'

const getToken: Getter<AuthState, RootState> = ({ token }) => token

export default getToken
